
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import LoginForm from './Login.js';
import LoginForm1 from './Login1.js';
import Dashboard from './Dashboard.js';
import Dashboard2 from './Dashboard1.js';
import Header from './Header.js';
import HeaderMobile from './HeaderMobile.js';
import Manage_User from './Manage_User.js';
import Manage_Candidates from './Manage_Candidates.js';
import Add_User from './Add_User.js';
import Add_DressType from './Add_DressType.js';

import Add_DressSize from './Add_DressSize.js';
import Add_Candidate from './Add_Candidate.js';
import Sidebar from './Sidebar.js';
import logo from './logo.svg';
import './App.css';
import Manage_DressType from './Manage_DressType.js';
import Edit_DressType from './Edit_DressType.js';
import Manage_DressSize from './Manage_DressSize.js';
import Manage_DressColor from './Manage_DressColor.js';
import Edit_DressSize from './Edit_DressSize.js';
import Edit_DressColor from './Edit_DressColor.js';

import Add_DressColor from './Add_DressColor.js';
import Mapping from './Mapping.js';

import Manage_Mapping from './Manage_Mapping.js';
import Edit_Mapping from './Edit_Mapping.js';
import Qr_Code from './Qr_Code.js';
import Printk from './Printk.js';
import Manage_Stocks from './Manage_Stocks.js';
import Edit_Stock from './Edit_Stock.js';
import Transfer_Stock from './Transfer_Stock.js';
import Add_Stock from './Add_Stock.js';
import Manage_Areas from './Manage_Areas.js';
import Add_Area from './Add_Area.js';
import Edit_Area from './Edit_Area.js';
import About from './About.js';
import Privacy from './Privacy-polocy.js';
import Terms from './Terms.js';
import Contact from './Contact.js';
import ChangePassword from './ChangePassword.js';
import ManageEmployee from './Manage_Employee.js';
import ManageIndent from './ManageIndent.js';
import AddEmployee from './Add_Employee.js';
import AddIndent from './AddIndent.js';
import ThankYou from './ThankYou.js';
import ManageCandidateReports from './Manage_Candidates_Reports.js';
import EmpList from './EmpList.js';
import OtpScreen from './OtpScreen.js';
import OtpScreen1 from './OtpScreen1.js';
import ManageStockReports from './ManageStockReports.js';
import Edit_Stock_Reports from './Edit_Stock_Reports.js';
import Manage_Stocks1 from './Manage_Stocks1.js';
import BackendPaymentUpdate from './BackendPaymentUpdate.js';
import ManageBackendPayments from './ManageBackendPayments.js';
import AreaWisePayment from './AreaWisePayment.js';
import AreaWiseShirtTrouser from './AreaWiseShirtTrouser.js';
import ReturnStock from './Return_Stock.js';
import FocusReport from './Focus_Report.js';
import IndentReports from './Indent_Reports.js';
import OverAllStockReport from './OverAllStockReport.js';
import OpeningStockReport from './OpeningStockReport.js';
import Add_Stock_Apron from './Add_Stock_Apron.jsx';
import PendingIndentReports from './PendingIndentReports.js';
import AddCandidateIndent from './Add_Candidate_Indent.js';
import GRNReport from './GRNReport.js';
import ConsumptionReport from './ConsumptionReport.js';
import Manage_Transfers from './Manage_Transfers.js';
import EditManageTransfer from './Transfer_Stock_Update.js';
import Manage_Return_Stock from './Manage_Return_Stock';
import Manage_MyExchange_Uniforms from './Manage_MyExchange_Uniforms';
import Get_Return_Stock from './Get_Return_Stock';









const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm />} />
        <Route path="/login1" element={<LoginForm1 />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard2" element={<Dashboard2 />} />
        <Route path="/header" element={<Header />} />
        <Route path="/headermobile" element={<HeaderMobile />} />
        <Route path="/sidebar" element={<Sidebar />} />
        <Route path="/manage_users" element={<Manage_User />} />
        <Route path="/add_user" element={<Add_User />} />
        <Route path="/manage_candidates" element={<Manage_Candidates />} />
        <Route path="/add_candidate" element={<Add_Candidate />} />
        <Route path="/manage_dresstype" element={<Manage_DressType />} />
        <Route path="/add_dresstype" element={<Add_DressType />} />
        <Route path="/get_dress_types/:id" element={<Edit_DressType />} />
        <Route path="/manage_dresssize" element={<Manage_DressSize />} />
        <Route path="/add_dresssize" element={<Add_DressSize />} />
        <Route path="/get_dress_sizes/:id" element={<Edit_DressSize />} />
        <Route path="/manage_dresscolor" element={<Manage_DressColor />} />
        <Route path="/add_dresscolor" element={<Add_DressColor />} />
        <Route path="/get_dress_colors/:id" element={<Edit_DressColor />} />
        <Route path="/mapping" element={<Mapping />} />
        <Route path="/manage_mapping" element={<Manage_Mapping />} />
        <Route path="/edit_mapping/:id" element={<Edit_Mapping />} />
        <Route path="/manage_stocks" element={<Manage_Stocks />} />
        <Route path="/qr_code/:id" element={<Qr_Code />} />
        <Route path="/printk/:id" element={<Printk />} />
        <Route path="/edit_stock/:id" element={<Edit_Stock />} />
        <Route path="/transfer_stock/:id" element={<Transfer_Stock />} />
        <Route path="/add_stock" element={<Add_Stock />} />
        <Route path="/manage_areas" element={<Manage_Areas />} />
        <Route path="/add_area" element={<Add_Area />} />
        
        <Route path="/get_area/:id" element={<Edit_Area />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/change_password" element={<ChangePassword />} />
        <Route path="/manage_employee" element={<ManageEmployee />} />
        <Route path="/manage_indent" element={<ManageIndent />} />
        <Route path="/add_employee" element={<AddEmployee />} />
        <Route path="/add_indent" element={<AddIndent />} />
        <Route path="/add_candidate_indent" element={<AddCandidateIndent />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/manage_candidate_reports" element={<ManageCandidateReports />} />
        <Route path="/emp_list" element={<EmpList />} />
        <Route path="/otp_screen/:id" element={<OtpScreen />} />
        <Route path="/otp_screen1/:id" element={<OtpScreen1 />} />
        <Route path="/manage_stock_reports" element={<ManageStockReports />} />
        <Route path="/edit_stock_reports/:id" element={<Edit_Stock_Reports />} />
        <Route path="/manage_stocks1" element={<Manage_Stocks1 />} />
        <Route path="/backend_payment_update" element={<BackendPaymentUpdate  />} />
        <Route path="/manage_backend" element={<ManageBackendPayments  />} />
        <Route path="/area_wise_payment_report" element={<AreaWisePayment  />} />
        <Route path="/area_wise_shirt_trouser" element={<AreaWiseShirtTrouser  />} />
        <Route path="/return_stock/:id" element={<ReturnStock />} />
        <Route path="/focus_report" element={<FocusReport />} />
        <Route path="/indent_reports" element={<IndentReports />} />
        <Route path="/overall_stock_reports" element={<OverAllStockReport />} />
        <Route path="/opening_stock_report" element={<OpeningStockReport />} />
        <Route path="/pending_indent_reports" element={<PendingIndentReports />} />
        <Route path="/add_stock_apron" element={<Add_Stock_Apron />} />
        <Route path="/grn_report" element={<GRNReport />} />
        <Route path="/consumption_report" element={<ConsumptionReport />} />
        <Route path="/manage_transfers" element={<Manage_Transfers />} />
        <Route path="/edit_manage_transfer/:id" element={<EditManageTransfer />} />
        <Route path="/manage_return_stock" element={<Manage_Return_Stock />} />
        <Route path="/manage_myexchange_uniforms" element={<Manage_MyExchange_Uniforms />} />
        <Route path="/get_return_stock/:id" element={<Get_Return_Stock />} />
        
        
        
        
        

        
        
      </Routes>
    </Router>
  );
};

export default App;
